import { useConfig, useNotification, useOidcWithAdmin } from '@revenuewell/front-end-bundle';
import { FC, useMemo, useState } from 'react';
import { usePatientProfile } from '../../../../../../../../hooks/use-patient-profile';
import {
  ContactApi,
  PatientPreferencesRequest,
  PatientPreferencesResponse
} from '../../../../../../../../services/api-client/contact-api';
import { PatientProfileHeader } from '../../../../header/header';
import { QuickNavMenu } from '../../../../header/quick-nav-menu/quick-nav-menu';
import { usePatientProfileWidget } from '../../../../hooks/use-patient-profile-widget';
import { WidgetRoutePath } from '../../../../navigation/route-config';
import { ViewContentWrapper } from '../../../shared/view-content/view-content.styles';
import { PreferencesViewWrapper } from '../../shared/preferences-view-wrapper/preferences-view-wrapper';
import CommunicationSubSection from '../../shared/sub-section/communication-sub-section';

export const PhoneCallPreferencesView: FC = () => {
  const { config } = useConfig();
  const { oidcService } = useOidcWithAdmin();
  const { showSuccess } = useNotification();
  const { goTo } = usePatientProfileWidget();
  const { patientPreferences, refreshPatientPreferences } = usePatientProfile();
  const [localPreferences, setLocalPreferences] = useState<PatientPreferencesResponse>(patientPreferences);
  const contactApi = useMemo(() => new ContactApi(config, oidcService), [config, oidcService]);

  const updateLocalPreferences = (state: Partial<PatientPreferencesResponse>) => {
    const newState = { ...localPreferences, ...state };
    setLocalPreferences(newState);
  };

  const updatePhoneCallPreferences = async () => {
    await contactApi.patchPatientPreferences(localPreferences.patientId, localPreferences as PatientPreferencesRequest);
    await refreshPatientPreferences();
    showSuccess('Phone call preferences successfully saved');
    goTo(WidgetRoutePath.COMM_PREFERENCES);
  };

  return (
    <>
      <PatientProfileHeader />
      <QuickNavMenu />
      <ViewContentWrapper>
        <PreferencesViewWrapper onSave={updatePhoneCallPreferences}>
          <CommunicationSubSection
            text="Appointment Confirmations"
            isChecked={localPreferences.pcAppointmentConfirmations}
            onChange={(value) => updateLocalPreferences({ pcAppointmentConfirmations: value })}
          />
        </PreferencesViewWrapper>
      </ViewContentWrapper>
    </>
  );
};
